<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6
      slot="header"
      class="modal-title text-success font-weight-bold"
      id="modal-title-default"
    >{{ title }}</h6>
    <div class="d-block">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form ref="form" @submit.stop.prevent="handleSubmit(submit)">
          <p class="description">* E-SPTPD, silahkan isi field di bawah ini.</p>
          <div class="alert alert-danger" v-if="error_msg.length > 0">
            <strong>Warning!</strong> Perbaiki hasil input Anda :
            <ul>
              <li v-for="text in error_msg" :key="text">{{ text }}</li>
            </ul>
          </div>
          <div class="mb-5">
            <!-- /.page-header -->
            <div class="row">
              <div class="col-md-12">
                <!-- / PAGE CONTENT START -->
                <div class="row">
                  <div class="col-md-4 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider name="Tahun SPT" rules="required" v-slot="{ errors }">
                        <label>Tahun SPT</label>
                        <select
                          class="form-control"
                          name="collection_year"
                          id="collection_year"
                          v-model="form.collection_year"
                          :class="[{'is-valid': (!errors[0]) === true}, {'is-invalid': (!errors[0]) === false}]"
                          @change="get_texes"
                        >
                          <option value disabled selected>--- Pilih Tahun ---</option>
                          <option
                            :value="year.value"
                            v-for="year in optionYear"
                            :key="year.value"
                          >{{year.text}}</option>
                        </select>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block"
                          v-if="errors[0]"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider
                        name="Masa Pajak Awal"
                        rules="required"
                        v-slot="{ errors }"
                      >
                      <label for="Masa Pajak Awal">Masa Pajak Awal</label>
                        <datepicker
                          placeholder="Masa Pajak Awal (YYYY-MM-DD)"
                          v-model="form.start_period"
                          :bootstrap-styling="true"
                          :class="[
                            { 'is-valid': !errors[0] },
                            { 'is-invalid': errors[0] },
                          ]"
                        ></datepicker>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block"
                          v-if="errors[0]"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider
                        name="Masa Pajak Akhir"
                        rules="required"
                        v-slot="{ errors }"
                      >
                      <label for="Masa Pajak Akhir">Masa Pajak Akhir</label>
                        <datepicker
                          placeholder="Masa Pajak Akhir (YYYY-MM-DD)"
                          v-model="form.final_period"
                          :bootstrap-styling="true"
                          :class="[
                            { 'is-valid': !errors[0] },
                            { 'is-invalid': errors[0] },
                          ]"
                        ></datepicker>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block"
                          v-if="errors[0]"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider name="NPWPD" rules="required" v-slot="{ errors }">
                      <label for="NPWPD">NPWPD</label>
                        <v-select
                          :options="registrations"
                          v-model="form.registration_id"
                          :reduce="(registration) => registration.id"
                          :getOptionLabel="
                            (registration) =>
                              registration.npwpd +
                              ' - ' +
                              registration.business_name
                          "
                          class="form-control"
                          :class="[
                            { 'is-valid': !errors[0] },
                            { 'is-invalid': errors[0] },
                          ]"
                          placeholder="~~ Pilih NPWPD ~~"
                        ></v-select>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block"
                          v-if="errors[0]"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider
                        name="Rekening Pajak"
                        rules="required"
                        v-slot="{ errors }"
                      >
                      <label for="Rekening Pajak">Rekening Pajak</label>
                        <v-select
                          :options="taxes"
                          v-model="selectedTaxes"
                          :getOptionLabel="(tax) => tax.code + ' - ' + tax.name"
                          class="form-control"
                          :class="[
                            { 'is-valid': !errors[0] },
                            { 'is-invalid': errors[0] },
                          ]"
                          placeholder="~~ Pilih Rekening Pajak ~~"
                          @input="setFare"
                        ></v-select>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block"
                          v-if="errors[0]"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <ValidationProvider name="Keterangan" rules="required" v-slot="{ errors }">
                      <base-text-area
                        label="Keterangan"
                        placeholder="Keterangan"
                        v-model="form.information"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-text-area>
                    </ValidationProvider>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-12">
                    <uploader
                      :options="options"
                      class="uploader-example"
                      @file-success="fileComplete"
                      ref="uploader"
                    >
                      <uploader-unsupport></uploader-unsupport>
                      <uploader-drop>
                        <p>Tarik file ke sini atau</p>
                        <uploader-btn>pilih files</uploader-btn>
                      </uploader-drop>
                      <uploader-list></uploader-list>
                    </uploader>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <b-table
                      striped
                      bordered
                      hover
                      responsive
                      id="my-table"
                      ref="table"
                      :items="file_uploads_temp"
                    ></b-table>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <label>Pajak</label>

                      <input
                        type="text"
                        :value="parseInt(form.fare) + '%'"
                        class="form-control text-right"
                        placeholder="Pajak"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider name="Omzet" rules="required" v-slot="{ errors }">
                        <label>Omzet</label>
                        <money
                          v-model="form.omzet"
                          v-bind="money"
                          class="form-control text-right"
                          placeholder="Omzet"
                        ></money>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block"
                          v-if="errors[0]"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>

                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider
                        name="Pajak yang harus dibayar"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <label>Pajak yang Harus Dibayar</label>
                        <money
                          v-model="form.total_tax"
                          v-bind="money"
                          class="form-control text-right"
                          placeholder="Pajak Yang harus dibayar"
                          readonly
                        ></money>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block"
                          v-if="errors[0]"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- / PAGE CONTENT ENDS -->
          <div class="row float-right">
            <div class="col-md-12 col-sm-12">
              <template v-if="isBusy">
                <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                <strong>Loading...</strong>
              </template>
              <base-button
                v-else
                type="success"
                nativeType="submit"
                icon="ni ni-send"
              >{{ edit ? "Update" : "Simpan" }}</base-button>
              <base-button type="warning" @click="modals.modal1 = false">Tutup</base-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </modal>
</template>
<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2";
import qs from "qs";
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { Money } from "v-money";
import Datepicker from "vuejs-datepicker";
import { BTable } from "bootstrap-vue";

export default {
  components: {
    Modal,
    PulseLoader,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    Money,
    Datepicker,
    BTable,
  },
  props: {
    title: {
      type: String,
      description: "Judul Modal",
    },
    code: {
      type: String,
      description: "Code Pajak",
    },
    url: {
      type: String,
      description: "Url Pajak",
    },
    business_id: {
      type: String,
      description: "Id NPWPD",
    }
  },
  watch: {
    "form.omzet": function () {
      this.form.total_tax = (this.form.omzet * this.form.fare) / 100;
    },
    "form.fare": function () {
      this.form.total_tax = (this.form.omzet * this.form.fare) / 100;
    },
  },
  data() {
    return {
      modals: {
        modal1: false,
      },
      file_uploads_temp: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "Rp. ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      form: {
        id: null,
        registration_id: null,
        tax_id: null,
        information: null,
        omzet: 0,
        total_tax: 0,
        fare: 0,
        final_period: null,
        start_period: null,
        file_uploads: [],
        collection_year: new Date().getFullYear(),
      },
      isBusy: false,
      registrations: [],
      taxes: [],
      error_msg: [],
      edit: false,
      fare: 0,
      selectedTaxes: [],
      options: {
        target:
          window.location.protocol +
          "//" +
          window.location.hostname +
          ":4000" +
          "/api/v1/upload",
        testChunks: false,
      },
      attrs: {
        accept: "*",
      },
      statusText: {
        success: "Sukses",
        error: "Gagal",
        uploading: "Proses Unggah",
        paused: "Terhenti",
        waiting: "Tunggu",
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      // window.uploader = this.$refs.uploader.uploader;
    });
  },
  computed: {
    optionYear() {
      var i = 0;
      var optionsYear = [];
      let year = new Date().getFullYear();
      for (i = 2019; i <= year; i++) optionsYear.push({ value: i, text: i });
      return optionsYear;
    },
  },
  methods: {
    fileComplete(rootFile, file, response, chunk) {
      this.form.file_uploads.push(response);
    },
    showModal() {
      this.items = [];
      this.edit = false;
      this.form.id = null;
      this.modals.modal1 = true;
      this.form.registration_id = null;
      this.form.fare = null;
      this.form.tax_id = null;
      this.form.information = null;
      this.form.omzet = 0;
      this.form.total_tax = 0;
      this.form.final_period = null;
      this.form.start_period = null;
      this.selectedTaxes = [];
      this.file_uploads_temp = [];
      let month = new Date().getMonth()
      this.form.collection_year = new Date().getFullYear();
      if(month == 0) this.form.collection_year -= 1
      this.get_registrations();
      this.get_texes();
    },
    updateMode(data) {
      this.form.registration_id = data.registration_id;
      this.form.tax_id = data.tax_id;
      this.form.information = data.information;
      this.form.fare = data.fare;
      this.form.omzet = parseFloat(data.omzet);
      this.form.final_period = data.final_period;
      this.form.start_period = data.start_period;
      this.form.total_tax = parseFloat(data.total_tax);
      this.selectedTaxes = data.tax;
      this.form.id = data.id;
      this.form.collection_year = parseFloat(data.collection_year);
      this.file_uploads_temp = data.file_uploader;
      this.edit = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
    async submit() {
      const me = this;
      try {
        me.error_msg = [];
        this.isBusy = true;
        let { data, status } = me.edit
          ? await axios.patch(
              "/api/v1/collection_taxes/" + me.form.id,
              qs.stringify({ collection_tax: me.form })
            )
          : await axios.post(
              "/api/v1/collection_taxes",
              qs.stringify({ collection_tax: me.form })
            );

        if (status >= 200 && status <= 202) {
          Swal.fire({
            title: "",
            text: me.edit
              ? "Update data berhasil."
              : "Pendataan Berhasil, Terima kasih sudah mendata pajak Anda. Pajak Anda membantu untuk memajukan Kabupaten Ketapang. Terima kasih",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Tutup!",
          }).then(() => {
            this.$emit("resetTable");
            me.hideModal();
          });
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        // console.log(error.response);
        me.error_msg = ['Terjadi gangguan pada server.'];
        Swal.fire({
          title: "",
          text: error.message,
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!",
        });
      } finally {
        this.isBusy = false;
      }
    },
    async get_registrations() {
      try {
        this.registrations = [];
        const me = this;
        this.isBusy = true;
        let { data } = await axios.get(
          "/api/v1/registrations?mode=1&business_id="+this.business_id+"&code=" + me.code.substring(2, 4)
        );
        this.registrations = data;
        this.isBusy = false;
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.message,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!",
        });
        this.isBusy = false;
      } finally {
        this.isBusy = false;
      }
    },
    async get_texes() {
      try {
        this.taxes = [];
        this.isBusy = true;
        let { data } = await axios.get(
          "/api/v1/taxes?code=" +
            this.code +
            "&year=" +
            this.form.collection_year
        );
        this.taxes = data;
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.message,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!",
        });
      } finally {
        this.isBusy = false;
      }
    },
    setFare(items) {
      this.fare = items.fare;
      this.form.tax_id = items.id;
      this.form.fare = items.fare;
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}

.uploader-example {
  padding: 15px;
  font-size: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}
.uploader-example .uploader-btn {
  margin-right: 4px;
}
.uploader-example .uploader-list {
  max-height: 440px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}
.has-success:after {
    margin-top: 30px;
    content: "\EA26";
    color: #1d8357;
    background-color: #69deac;
}

.has-danger:after {
    margin-top: 30px;
    content: "\EA53";
    color: #db2d05;
    background-color: #fda08b;
}
</style>